module.exports = __webpack_public_path__ + "img/35.44aa7234.jpg";